/**
 * Created by a2dd on 2017-03-28.
 */
jQuery(document).ready(function($) {
    $('.recurring-events-show-more').click(function (e) {
        e.preventDefault();

        var lastevent = $('#recurring-events li:last').attr('data-eventid');
        var data = {
            'action': 'events_recurring',
            'event': lastevent,
            'direction': '1'
        };

        $.post('/wp-admin/admin-ajax.php', data, function(response) {
            console.log(response.data.hasmore);
            $('#recurring-events').append(response.data.events);
            if (response.data.hasmore == false)
            {
                $('.recurring-events-show-more').hide();
            }
        });
    });

    $('.recurring-events-show-prev').click(function (e) {
        e.preventDefault();

        var firstevent = $('#recurring-events li:first').attr('data-eventid');
        var data = {
            'action': 'events_recurring',
            'event': firstevent,
            'direction': '-1'
        };

        $.post('/wp-admin/admin-ajax.php', data, function(response) {
            $('#recurring-events').prepend(response.data.events);
            if (response.data.hasmore == false)
            {
                $('.recurring-events-show-prev').hide();
            }
        });
    });
});
